import React, { Component, useEffect, useState } from 'react';
// import { TargetsAPI } from '@coinscrap/webapp-core/components/sdk';

export const DocuSign = ({ url, onProcessFinished }) => {
  const [loads, setLoads] = useState(0);

  useEffect(() => {
    if (loads >= 2) {
      onProcessFinished && onProcessFinished();
    }
  }, [loads, onProcessFinished]);

  return (
    // eslint-disable-next-line react/jsx-fragments
    <React.Fragment>
      {!loads
        ? /*
        Add a overlay component here. Example
        <div style={{position: 'absolute', top: '50%', width: '100%', display: 'flex'}}>
          Procesando Firma
        </div>
        */

          null
        : null}
      <iframe
        src={url}
        onLoad={() => {
          //console.log('LOADED');
          setLoads((prevLoads) => prevLoads + 1);
        }}
        title="iframe"
        style={{
          height: '100%',
          backgroundColor: 'white',
          minHeight: '100vh',
          width: '100%',
          overflow: 'auto',
          frameBorder: 0,
          borderWidth: 0,
          marginTop: 30,
          marginBottom: 40,
        }}
      />
    </React.Fragment>
  );
};
